import { PredefinedConfiguration, SofaConfigurationItem } from 'sofa-reborn-react';
export class ConfigurationParser {
	private static parseConfigurationItem(item: SofaConfigurationItem): SofaConfigurationItem {
		const parsedItem = item;
		parsedItem.articleId = item.articleId && item.articleId.replace('G', '');
		return parsedItem;
	}
	public static parseConfiguration(sofaData: PredefinedConfiguration): PredefinedConfiguration {
		const parsedVpcConfiguration: PredefinedConfiguration = {
			configuration: sofaData.configuration,
		};

		if (
			parsedVpcConfiguration &&
			parsedVpcConfiguration.configuration &&
			parsedVpcConfiguration.configuration.children &&
			parsedVpcConfiguration.configuration.children.length > 0
		) {
			const parsedChildItems = parsedVpcConfiguration.configuration.children.map(
				(childItem: SofaConfigurationItem) => {
					const parsedChildItem = ConfigurationParser.parseConfigurationItem(childItem);
					if (childItem && childItem.children) {
						const parsedGrandChildItems = childItem.children.map(
							(grandChildItem: SofaConfigurationItem) => {
								return this.parseConfigurationItem(grandChildItem);
							}
						);
						parsedChildItem.children = parsedGrandChildItems;
					}
					return parsedChildItem;
				}
			);
			parsedVpcConfiguration.configuration.children = parsedChildItems;
		}
		return parsedVpcConfiguration;
	}
}
